var map = {
	"./datoteka.svg": "xipC",
	"./dropdown.svg": "D7wK",
	"./en.svg": "yFi6",
	"./oseba.svg": "tYhG",
	"./sl.svg": "eV+F"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "UFRR";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons ^\.\/.*\.svg$
// module id = UFRR
// module chunks = 1 2 3